module.exports = __webpack_public_path__ + "media/auth/sign_in-1a8b6635.svg";